import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { ACTIVITY_TYPE } from '@/consts/Activity';
import { API_ENDPOINT } from '@/config/endpoint';

export const useGetArchitectureList = (techstackIds, category, company) => {
  const keyArr = [...techstackIds, category, company].filter(
    (item) => item !== ''
  );

  return useInfiniteQuery(
    ['architecture', 'list', ...keyArr],
    ({ pageParam }) => {
      return API_ENDPOINT.architecture.getArchitectureList(
        category,
        techstackIds.join(),
        pageParam,
        company
      );
    },
    {
      getNextPageParam: (lastPage: any) => {
        return lastPage.end_cursor;
      },
      staleTime: 1000 * 60 * 10,
    }
  );
};

export const useGetFavoriteArchitecture = () => {
  return useQuery(
    ['architecture', 'favorite', 'ids'],
    API_ENDPOINT.architecture.getFavoriteArchitectureID,
    {
      staleTime: 60000,
    }
  );
};

export const useGetArchitectureInfo = () => {
  return useQuery(
    ['architecture', 'basicinfo'],
    API_ENDPOINT.architecture.getBasicInfo
  );
};

export const useGetArchitecturePopular = () => {
  return useQuery(
    ['architecture', 'popular_article'],
    API_ENDPOINT.architecture.getPopularArchitecture
  );
};

export const useGetArchitectureDetail = (id) => {
  return useQuery(['architecture', id], () =>
    API_ENDPOINT.architecture.getArchitectureDetail(id)
  );
};

export const useGetArchitectureDetailComment = (id) => {
  return useQuery(
    ['architecture', 'comment', id],
    () => API_ENDPOINT.comment.getCommentList(ACTIVITY_TYPE.architecture, id),
    {
      select: (data) => data.items,
    }
  );
};
